export default __webpack_public_path__ + "static/media/ic_header_arrow_left.83138a3c.svg";